import { CSSProperties, ElementType, ReactNode } from 'react';

interface AccessiblePriceProps {
  as?: ElementType;
  value?: ReactNode;
  label?: ReactNode;
  className?: string;
  visualClassName?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

export default function AccessiblePrice({
  as: Component = 'span',
  value,
  label,
  className,
  visualClassName,
  style,
  children,
}: AccessiblePriceProps) {
  const visualValue = children ?? value;

  if (visualValue === undefined || visualValue === null || visualValue === '') return null;

  return (
    <Component className={className} style={style}>
      <span className={visualClassName} aria-hidden="true">
        {visualValue}
      </span>
      <span className="sr-only">
        {label}
        {value ?? visualValue}
      </span>
    </Component>
  );
}
